// extracted by mini-css-extract-plugin
export default {"container":"Home_container__5xSil","card":"Home_card__ehRyT"};